'use client'

import { useDialogState } from '@/shared/lib'
import { Button, Icon } from '@/shared/ui'

import { PASSPORT_VERIFICATION_DIALOG } from './passport-dialog'

export type Props = {
  isVerified?: boolean
}

export const PassportVerificationButton = ({ isVerified = false }: Props) => {
  const { open } = useDialogState()

  const handleClick = () => {
    open(PASSPORT_VERIFICATION_DIALOG, { closeOnOpen: true })
  }

  return (
    <>
      {(() => {
        if (isVerified) {
          return (
            <Button
              variant="outline"
              shape="pill"
              size="large"
              className="w-full"
              onClick={handleClick}
            >
              여권 다시 등록하기
              <Icon name="arrow-right" size={24} />
            </Button>
          )
        }

        return (
          <Button
            variant="outline"
            shape="pill"
            size="medium"
            className="w-55"
            onClick={handleClick}
          >
            여권으로 본인인증하기
            <Icon name="arrow-right" size={24} />
          </Button>
        )
      })()}
    </>
  )
}
